import React from "react";
import { NavLink } from "react-router-dom";
import logo1 from "../../assets/imagesOld/logo1.png";
import { developingMessage } from "../../utils/msg";
import { getBrowseNumber } from "../../utils/api";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalNum: "0",
    };
  }
  componentDidMount = () => {
    // this.getNumber();
  };
  getNumber = async () => {
    let data = await getBrowseNumber();
    if (data?.code == 0) {
      let totalNum = data?.data?.browseNumber + "";
      // 不够四位前置补0
      this.setState({
        totalNum: totalNum.padStart(4, 0),
      });
    }
  };
  render() {
    const { t } = this.props;
    const navigation = t("navigation", {
      returnObjects: true,
    });
    const home = t("home", {
      returnObjects: true,
    });
    const homeList = [
      home.anchorPoint1,
      home.anchorPoint2,
      home.anchorPoint3,
      home.anchorPoint4,
    ];
    const productList = [
      { name: navigation.product1, link: "/solution/archives" },
      { name: navigation.product2, link: "/solution/infoServices" },
      { name: navigation.product3, link: "/solution/asset" },
      { name: navigation.product4, link: "/solution/spaceOperations" },
      { name: navigation.product5, link: "/solution/residency" },
    ];
    return (
      <div className="nav-footer" id="content_footer">
        <div className="nav-footer_top">
          <div className="nav-footer_top_con">
            <ul className="nav-footer_topContent">
              <li className="tit">{navigation.footer1}</li>
              <li style={{ marginTop: "10px" }}>
                <img
                  src={require("../../assets/images/logo.png").default}
                ></img>
              </li>
            </ul>
            <ul className="nav-footer_topContent">
              <li className="tit">{navigation.footer2}</li>
              {homeList.map((item, index) => {
                return (
                  <li key={index}>
                    <NavLink
                      to={{
                        pathname: "/home",
                        state: { activePoint: index },
                      }}
                      className="nav-footer_topLeft_content"
                    >
                      {item}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            <ul className="nav-footer_topContent">
              <li className="tit">{navigation.product}</li>
              {productList.map((item, index) => {
                return (
                  <li key={index}>
                    <NavLink
                      to={item.link}
                      className="nav-footer_topLeft_content"
                    >
                      {item.name}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            <ul className="nav-footer_topContent">
              <li className="tit">{navigation.success}</li>

              {productList.map((item, index) => {
                return (
                  <li key={index}>
                    <NavLink
                      to={{
                        pathname: "/successStories",
                        state: { activePoint: index, isDisabled: true },
                      }}
                      className="nav-footer_topLeft_content"
                    >
                      {item.name}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            <ul className="nav-footer_topContent">
              <li className="tit">{navigation.about}</li>
              {navigation.footer5Con.map((item, index) => {
                return (
                  <li key={index}>
                    <NavLink
                      to={{ pathname: "/aboutUs" }}
                      className="nav-footer_topLeft_content"
                    >
                      {item}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            <ul className="nav-footer_topContent">
              <li className="tit">{navigation.footer6}</li>
              {navigation.footer6Con1.map((item, index) => {
                return (
                  <li key={index}>
                    {item.til}：{item.con}
                  </li>
                );
              })}
              <li style={{ display: "flex", textAlign: "center" }}>
                <div style={{ margin: "10px 10px 10px 0" }}>
                  <img
                    style={{width:'80px'}}
                    src={require("../../assets/images/wx.jpg").default}
                    alt=""
                  />
                  <div>{navigation.footer6Con2.con1}</div>
                </div>
                <div style={{ margin: "10px 0 10px 10px" }}>
                  <img
                    style={{width:'80px'}}
                    src={require("../../assets/images/gzh.jpg").default}
                    alt=""
                  />
                  <div>{navigation.footer6Con2.con2}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="nav-footer_bottom">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <div
              style={{ padding: "20px", textAlign: "center", color: "#333" }}
            >
              Copyright 2025 www.hl-oa.cn @版权所有
              <a
                href="http://beian.miit.gov.cn/"
                target="_blank"
                style={{ color: "#333" }}
              >
                &nbsp; 沪ICP备2025109763号-4
              </a>
              &nbsp;
            </div>
          </div>
          <div className="col-lg-2"></div>
        </div>
      </div>
    );
  }
}

export default withRouter(withTranslation()(Footer));
